import { brandConfig } from "config/brandConfig";

type CategorySEOConfig = {
  title: string;
  description: string;
  canonicalPath: `/${string}`;
  categoryName: string;
};

export const productsCategoryData: CategorySEOConfig = {
  title: "Armoires à fusils – Tous nos modèles",
  description: `Découvrez notre gamme d'armoires à fusils ${brandConfig.brandName} sécurisées, conçues pour garantir la sécurité de vos armes à feu.`,
  canonicalPath: "/produits",
  categoryName: "Armoires à fusils",
};
